import styled from 'styled-components';

export const PricingQuizIframe = styled.iframe`
  border: none;
  max-width: 100%;
  margin: 0;
`;

export const PricingQuizPadding = styled.div`
  padding: 10px 5px;
  border-radius: 8px;
  background-color: white; // Non-standard, quiz iframe uses this color
`;

export const PricingQuizLayout = styled.div`
  padding: 100% 0 0 0;
  margin-bottom: 5px;
  position: relative;
`;

export const PricingQuizIframeContainer = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;
